<div class="container">
  <div class="welcome-container">
    <div class="left-section-container">
      <div class="join-us-container">
        <div class="join-us">
          <p i18n>Join us now!</p>
          <img src="assets/merchant-landing-page/cherry-icon.svg">
        </div>
      </div>
      <h1 i18n>Turn Your Culinary Passion into Profits: Join Our Thriving Marketplace of Home Chefs!</h1>
      <h2 i18n>Connect with Food Lovers Nationwide & Grow Your Home-Based Culinary Business</h2>
      <button class="button-primary" routerLink="/merchants/signup" routerLinkActive="active" i18n>Get Started</button>
<!--      <img class="join-use-review-icon" src="assets/merchant-landing-page/svg/join-us-review.svg" />-->
    </div>
    <div class="hero-img-div">
      <img src="assets/merchant-landing-page/join-us.png" />
    </div>
  </div>
</div>
